// extracted by mini-css-extract-plugin
export default {"root":"style_root__7ngLu","title":"style_title__eGAoe","content":"style_content__YQOn4","contentItem":"style_contentItem__G2Qx-"};